module.exports = __webpack_public_path__ + "9ea6932d8d2f60954a5ea9ff04d42da8.png";